
import Vue from "vue";

export default Vue.extend({
    name: "AppError",
    props: {
        errorMessage: {
            type: String,
            required: true,
            default: "",
        },
        showError: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    methods: {
        updated(newValue: boolean) {
            this.$emit("updated", newValue);
        },
    },
});
